import { Injectable } from '@angular/core';
import { ICommand } from '../controller/ICommand';
import { Message } from '../utils/Message';
import { Response } from '../controller/Response';
import { IAppliationController } from '../controller/IAppliationController';
import { State } from '../controller/StateFile';


@Injectable({
  providedIn: 'root'
})
export class ApplicationControllerService implements IAppliationController{

  state:State = State.SENDING_LOGIN;
  states:Map<string, Map<State, Response>>;

  constructor() { 
    this.state = State.SENDING_LOGIN;
    this.states = new Map();
  }

  
  setState(s:State):void
  {
    this.state = s;
  }
  
  getState():State
  {
    return this.state;
  }
  
  getStatusAsString():string
  {
    return State[this.state];
  }
  
  addResponse(action:string, s:State, command:ICommand, view:string):void
  {
    if (this.states[action] == null)
    {
      this.states[action] = new Map();
    }
    this.states[action][s] = new Response(view, command);
  }
  
  getDomainCommandForAll(mes:Message) : ICommand {
    if (this.states[mes.name] == null)
    {
      return null;
    }
    if (this.states[mes.name][ State.ALL ] == null)
    {
      return null;
    }else {
      return this.states[mes.name][ State.ALL ].command;			
    }
  }
  getDomainCommand(mes:Message):ICommand
  {
    if (this.states[mes.name] == null)
    {
      return null;
    }
    if (this.states[mes.name][this.state] == null)
    {
      return null;
    }
    return this.states[mes.name][this.state].command;
  }
  ;
  
  getView(mes:Message):String
  {
    if (this.states[mes.name] == null)
    {
      return null;
    }
    if (this.states[mes.name][this.state] == null)
    {
      return null;
    }
    return this.states[mes.name][this.state].view;
  }
  ;
  
  printGrapViz():void
  {
    /*trace("digraph ClientMachine { \n");
    for (var action:String in states)
    {
      for (var state in states[action])
      {
        var resp:Response = Response(states[action][state]);
        var stateName:String = State.getStringStatus(state);
        var nextStatus:int = resp.command.getState();
        if (nextStatus >= 0)
        {
          trace(stateName + " -> " + State.getStringStatus(resp.command.getState()) + " ; \n");
        }
        else
        {
          trace(stateName + " -> " + stateName + " ; \n");
        }
      }
    }
    trace("}");*/
  }

}
